import { Select } from "antd";
import React, { useEffect, useState } from "react";
import Table from "./table";
import axios from "axios";
import { useSelector } from "react-redux";

const Main = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [secondDropdownOptions, setSecondDropdownOptions] = useState([]);
  const [cancelTokenSource, setCancelTokenSource] = useState(null);
  const dataUser = useSelector((state) => state.dataUser);
  const [data, setData] = useState([]);
  const [type, setType] = useState(null);
  const { Option } = Select;
  const [location, setLocation] = useState(null);
  const [cost, setCost] = useState({
    inventoryAcknowledgedCost: null,
    inventoryCost: null,
  });
  const [tableData, setTableData] = useState([]);

  //Get Listing
  useEffect(() => {
    if (type === null) {
      return;
    }

    const delay = 1000;
    const timeoutId = setTimeout(() => {
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Operation canceled by the user.");
      }

      const newCancelTokenSource = axios.CancelToken.source();
      setCancelTokenSource(newCancelTokenSource);

      const params = {
        // limit: 6,
        // skip: 0,
        // page: page,
        sortBy: "createdAt:desc",
        ...(type && { type }),
      };

      fetchAllAccess(params, newCancelTokenSource);
    }, delay);

    return () => {
      clearTimeout(timeoutId);

      if (cancelTokenSource) {
        cancelTokenSource.cancel("Operation canceled by the user.");
      }
    };
  }, [type]);

  const fetchAllAccess = (params, cancelTokenSource) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/v1/mhsss-facility`, {
        headers: {
          Authorization: `Bearer ${dataUser?.data?.tokens?.access?.token}`,
        },
        params,
        cancelToken: cancelTokenSource.token,
      })
      .then((res) => {
        setData(res?.data?.rows);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (type === null && location === null) {
      return;
    }
    const params = {
      mhsssfacilityId: location,
      ...(type && { type }),
    };

    if (type === "master-warehouse") {
      delete params?.mhsssfacilityId;
    }

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/v1/mhsss-facility/inv-cost`, {
        headers: {
          Authorization: `Bearer ${dataUser?.data?.tokens?.access?.token}`,
        },
        params,
      })
      .then((res) => {
        setCost({
          inventoryAcknowledgedCost: res?.data?.inventoryAcknowledgedCost,
          inventoryCost: res?.data?.inventoryCost,
        });
        inventoryCostDetail(params);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [location]);

  const statusesOptions = [
    {
      label: "Master Warehouse",
      value: "master-warehouse",
    },
    {
      label: "Warehouse",
      value: "warehouse",
    },
    {
      label: "Department",
      value: "department",
    },
    {
      label: "Location",
      value: "location",
    },
  ];

  const handleFirstSelectChange = (value) => {
    setType(value);
    setSelectedOption(value);
    setLocation(null);
    setCost({
      inventoryAcknowledgedCost: null,
      inventoryCost: null,
    });
    setTableData([])
  };

  const inventoryCostDetail = (params) => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/v1/mhsss-facility/list-inventory-cost-details`,
        {
          headers: {
            Authorization: `Bearer ${dataUser?.data?.tokens?.access?.token}`,
          },
          params,
        }
      )
      .then((res) => {
        setTableData(res?.data?.inventoryCostDetails);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const options = data?.map((item) => ({
    value: item?.id,
    label: item?.name,
    address: [
      item?.lot,
      item?.address,
      item?.regionNo,
      item?.regionName,
      item?.city,
      item?.ward,
    ]
      .filter(Boolean)
      .join(", "),
  }));

  const renderOption = (option) => (
    <Option key={option?.value} value={option?.value}>
      <div className="flex flex-col">
        <h1 className="font-semibold text-gray-700 text-[0.95rem]">
          {option?.label}
        </h1>
        <p className="text-sm text-gray-500 break-words whitespace-normal overflow-wrap-break-word">
          {option?.address}
        </p>
      </div>
    </Option>
  );
  return (
    <div>
      <div className="bg-white flex sm:p-6 p-2 rounded-md  w-full gap-4 mb-2 sm:flex-row flex-col">
        <div className="sm:flex-1 flex flex-col justify-between">
          <div className="flex items-center justify-between w-full">
            <p className="mr-4 text-[0.95rem] font-semibold text-gray-600 w-3/5">
              Calculate inventory cost by
            </p>
            <Select
              placeholder="Filter"
              allowClear
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
              onChange={handleFirstSelectChange}
              size="middle"
              className="w-2/5 wow"
              options={statusesOptions}
              value={selectedOption}
              onClear={() => {
                setLocation(null);
                setCost({
                  inventoryAcknowledgedCost: null,
                  inventoryCost: null,
                });
              }}
            />
          </div>
          <div
            className={`${
              selectedOption === null ||
              selectedOption === "" ||
              selectedOption === undefined
                ? "hidden"
                : "flex items-center justify-between w-full mt-3"
            }`}
          >
            <p className="mr-4 text-[0.95rem] font-semibold text-gray-600 w-3/5 capitalize">
              Select {selectedOption}
            </p>

            <Select
              placeholder={
                type === "warehouse"
                  ? "Select Warehouse"
                  : type === "department"
                  ? "Select Department"
                  : "Select Location"
              }
              className="w-[100%] woww "
              renderOption={renderOption}
              onChange={(value) => {
                // Find the selected option based on the value

                setLocation(value);
              }}
              value={location !== "" ? location : null}
            >
              {options?.map(renderOption)}
            </Select>
          </div>
        </div>
        <div className="sm:flex-1 flex flex-col gap-3">
          <div className="bg-[#F6F4F4] flex-1 flex items-center justify-between p-3">
            <h1 className="font-medium ">Total Inventory Cost</h1>
            <div className="text-center font-semibold text-[1.2rem]">
              {cost?.inventoryCost !== null && cost?.inventoryCost !== undefined
                ? `$${cost.inventoryCost}`
                : "----"}
            </div>
          </div>
          <div className="bg-[#F6F4F4] flex-1 flex items-center justify-between p-3">
            <h1 className="font-medium ">Acknowledged Cost</h1>
            <div className="text-center font-semibold text-[1.2rem] ">
              {cost?.inventoryAcknowledgedCost !== null &&
              cost?.inventoryAcknowledgedCost !== undefined
                ? `$${cost.inventoryAcknowledgedCost}`
                : "----"}
            </div>
          </div>
        </div>
      </div>
      {tableData?.length === 0 ? null : (
        <>
          <h1 className="text-[1.1rem] font-semibold text-gray-600 py-4">
            Inventory Detail
          </h1>
          <Table data={tableData} />
        </>
      )}
    </div>
  );
};

export default Main;
